export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f35b845bd7ec87761134104488d1012ef43b56dd2&name=fetchTypeahead!'